import { Dispatch, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { initialise as initialiseEventManager } from 'managers/eventManager/EventManager';
import { useFeatureToggleContext } from 'providers/featureToggleProvider/FeatureToggleProvider';
import { useGetQuoteData } from '../useGetQuote/useGetQuoteData';
import { SessionPropertiesType } from '../../contexts/sessionProvider/sessionType';
import { ADD_ON_SKUS, FEATURE_TOGGLE, getThemeByProductId, SUBSCRIPTION_TYPE } from '../../constants';
import { getRegionFromLegalEntity } from '../../utils/mapQuoteToProductData';

export const useUpdateQuoteSessionState = (
  state: SessionPropertiesType,
  setState: Dispatch<Partial<SessionPropertiesType>>
): void => {
  const history = useHistory();
  const { isFeatureEnabled } = useFeatureToggleContext();
  const isQuoteApiUpliftEnabled = isFeatureEnabled(FEATURE_TOGGLE.QUOTE_API_UPLIFT);
  const {
    data: quoteData, isError, isSuccess, isLoading
  } = useGetQuoteData(state.quoteId);

  useEffect(() => {
    if (isLoading) return;
    if (isError) {
      setState({ isInitialised: true });
      history.push('/error');
      return;
    }
    if (isSuccess && quoteData) {
      const productIds = quoteData.products.map((it) => it.productId);
      const baseProduct = quoteData.products.find((it) => !ADD_ON_SKUS.includes(it.productId))!;
      const productId = baseProduct.productId;
      const addonIds = productIds.filter((it) => ADD_ON_SKUS.includes(it));
      const promoCode = baseProduct.discounts?.[0]?.promoCode || '';
      const theme = getThemeByProductId(productId, addonIds);

      if (isQuoteApiUpliftEnabled) {
        const isAnnualPrice = state.isAnnualRoute ||
          baseProduct.billingFrequency?.toUpperCase() === 'ANNUAL';

        initialiseEventManager({ theme, subscriptionType: SUBSCRIPTION_TYPE.QUOTE });
        setState({
          productId,
          promoCode,
          email: quoteData.contact.email,
          theme,
          addonIds,
          region: getRegionFromLegalEntity(quoteData.legalEntity),
          isAnnualPrice,
          isInitialised: true,
          quoteDetails: {
            businessName: quoteData.account.businessName,
            firstName: quoteData.contact.firstName,
            lastName: quoteData.contact.lastName,
            phoneNumber: quoteData.contact.phone
          }
        });
        return;
      }

      setState({
        productId,
        pc: quoteData.products[0].discounts?.[0]?.promoCode || '',
        email: quoteData.contact.email,
        theme,
        addonIds,
        quoteDetails: {
          businessName: quoteData.account.businessName,
          firstName: quoteData.contact.firstName,
          lastName: quoteData.contact.lastName,
          phoneNumber: quoteData.contact.phone
        }
      });
    }
  }, [
    isError,
    isSuccess,
    isLoading]);
};
